import { Injectable, Pipe, PipeTransform } from '@angular/core';
/*
  Generated class for the TipoContaFilter pipe.

  See https://angular.io/docs/ts/latest/guide/pipes.html for more info on
  Angular 2 Pipes.
*/
@Pipe({
  name: 'tipocontafilter'
})
@Injectable()
export class TipoContaFilter implements PipeTransform {
  transform(item: any, args: any[]): any {
    if (args != []) {
      return args.filter((arg) => arg.id == item).map((objetoFiltrado) => {
        return objetoFiltrado.dsTipoConta;
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/tipo-conta-filter.ts